//TODO : Refactor after ai
import type { ReactNode } from "react";
import { ViacidShell } from "@pages/viacid";

interface LayoutWrapperProps {
  children: ReactNode;
  showLayout?: boolean;
}

/**
 * Wrapper component that conditionally applies AppLayout
 * Use showLayout=false for pages like Login that don't need the layout
 */
export function LayoutWrapper({
  children,
  showLayout = true,
}: LayoutWrapperProps) {
  if (!showLayout) {
    return <>{children}</>;
  }

  return <ViacidShell>{children}</ViacidShell>;
}
